import { useEffect, useRef } from "react";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import {
  ActionButton,
  checkImage,
  ToggleSwitch,
} from "../../../helper/ImageFormat";
import dateformate from "../../../helper/DateFormate";

const BrandTable = ({
  loading,
  brands,
  currentPage,
  perPage,
  handleEditClick,
  handleDelete,
  handleStatusToggle,
  totalCount,
  totalPages,
  handlePageClick,
  selected,
  setSelected,
}) => {
  const selectAllRef = useRef(null);
  const isAllSelected = brands.length > 0 && selected.length === brands.length;
  const isIndeterminate =
    selected.length > 0 && selected.length < brands.length;


  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  const toggleSelectAll = () => {
    setSelected(isAllSelected ? [] : brands.map((b) => b.id));
  };

  const toggleSelectOne = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };

  return (
    <div className="row">
      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table
                className="custom-table table table-striped"
                id="myTable"
                style={{ marginTop: "3px" }}
              >
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        ref={selectAllRef}
                        checked={isAllSelected}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Updated At</th>
                    <th>Is Active</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="text-center">
                        <Spinner />
                      </td>
                    </tr>
                  ) : brands.length > 0 ? (
                    brands.map((data, index) => (
                      <tr
                        key={data.id}
                        className={selected.includes(data.id) ? "table-active" : ""}
                      >
                        <td>
                          <input
                            type="checkbox"
                            checked={selected.includes(data.id)}
                            onChange={() => toggleSelectOne(data.id)}
                          />
                        </td>
                        <td>{checkImage(data.image)}</td>
                        <td>{data.name}</td>
                        <td>{dateformate(data.updatedAt)}</td>
                        {/* <td>{dateformate(data.createdAt)}</td> */}
                        <td>
                          <ToggleSwitch
                            data={data}
                            name="isActive"
                            checked={data.isActive}
                            handleStatusToggle={handleStatusToggle}
                            module={"brands"}
                          />
                        </td>
                        <td>
                          <ActionButton
                            data={data}
                            handleEditClick={handleEditClick}
                            handleDelete={handleDelete}
                            module={"brands"}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        <h4>No data available</h4>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {brands.length > 0 && (
              <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageClick}
                perPage={perPage}
                totalCount={totalCount}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandTable;
